import { render, staticRenderFns } from "./ReviewConfirm.vue?vue&type=template&id=9f696ef6&scoped=true"
import script from "./ReviewConfirm.vue?vue&type=script&lang=js"
export * from "./ReviewConfirm.vue?vue&type=script&lang=js"
import style0 from "./ReviewConfirm.vue?vue&type=style&index=0&id=9f696ef6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f696ef6",
  null
  
)

export default component.exports